export const NEW_SIGNAL_EVENT_NAME = 'new_signal'